export const pillsAnimation = ($, gsap) => {
  const $win = $(window);
  // *****************
  // Landing page animation for pills
  // *****************
  $(".landing-container .landing .pill-container").each(function (
    index,
    element
  ) {
    let windowWidth = window.innerWidth,
      // Set number to use for random margin and transform position
      // using a higher number for wider devices
      transformRange = windowWidth < 550 ? 50 : 200,
      size = Math.floor(Math.random() * 125 + 125),
      location = window.location.origin;

    // Runs on load to set random position and size
    $(this).css("width", size + "px");
    $(this).css("height", size + "px");

    // We scale down the pills for smaller devices
    // so they don't fill the page
    const adjustPillWidth = () => {
      if (window.innerWidth < 550) {
        gsap.set($(this), {
          scale: 0.5,
        });
      } else if (window.innerWidth < 1100) {
        gsap.set($(this), {
          scale: 0.65,
        });
      } else if (window.innerWidth < 1440) {
        gsap.set($(this), {
          scale: 0.8,
        });
      } else {
        gsap.set($(this), {
          scale: 1,
        });
      }
    };
    adjustPillWidth();
    let resizeTimer;

    $win.on("resize", function (e) {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        adjustPillWidth();
      }, 250);
    });

    let pillArray = [
      "dark-blue-pill.svg",
      "light-blue-pill.svg",
      "green-pill.svg",
    ];
    // Shuffle pill array so that every time we load the page
    // each position pill gets a different pill colour
    const Shuffle = (o) => {
      for (
        var j, x, i = o.length;
        i;
        j = parseInt(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x
      );
      return o;
    };

    //Apply shuffled pills to pill elements
    pillArray = Shuffle(pillArray);
    $(".landing .pill-container.top-right img").attr(
      "src",
      `/wp-content/themes/harpal/src/assets/img/pills/${pillArray[0]}`
    );
    $(".landing .pill-container.bottom-right img").attr(
      "src",
      `/wp-content/themes/harpal/src/assets/img/pills/${pillArray[1]}`
    );
    $(".landing .pill-container.bottom-left img").attr(
      "src",
      `/wp-content/themes/harpal/src/assets/img/pills/${pillArray[2]}`
    );

    gsap.timeline().to($(this), {
      x: `random(-${transformRange}, ${transformRange}, 1)`,
      y: `random(-${transformRange}, ${transformRange}, 1)`,
      duration: "random(18, 30, 1)",
      ease: "none",
      rotation: "random(-450, 450, 1)",
      repeat: -1,
      repeatRefresh: true, // gets a new random x and y value on each repeat
    });
  });

  // *****************
  // Blog page animation for pills
  // *****************
  const blogPagePillAnimations = (element) => {
    element.each(function () {
      const blogArticleHeight = $(this)[0].clientHeight;
      // run function if blog post module contains pill-containers
      if ($(this).children(".pill-container").length > 0) {
        const pills = $(this).children(".pill-container");

        pills.each(function (index, element) {
          //choose random side of blog post to render pill on
          const side =
              Math.floor(Math.random() * 2 + 0) === 0 ? "left" : "right",
            // Set number to use for random margin and transform position
            transformRange = 50,
            //Set a random position of height for pill
            randTop = Math.floor(Math.random() * blogArticleHeight - 200 + 200),
            //Set a random size for pill
            size = Math.floor(Math.random() * 100 + 100);

          // Runs on load to set random position and size
          $(this).css("width", size + "px");
          $(this).css("height", size + "px");
          $(this).css(side, 0);
          $(this).css("top", randTop + "px");

          gsap.timeline().to($(this), {
            x: `random(-${transformRange}, ${transformRange}, 1)`,
            y: `random(-${transformRange}, ${transformRange}, 1)`,
            duration: "random(18, 30, 1)",
            ease: "none",
            rotation: "random(-450, 450, 1)",
            repeat: -1,
            repeatRefresh: true, // gets a new random x and y value on each repeat
          });
        });
      }
    });
  };

  // *****************
  // Column module pills
  // *****************
  $(".column-module .pill-wrapper").each(function () {
    const wrapperHeight = $(this)[0].clientHeight;
    const wrapperWidth = $(this)[0].clientWidth;
    const pills = $(this).children(".pill-container");
    const distances = [[40], [0, 40], [0, 30, 60]];

    pills.each(function (index, element) {
      const transformRange = 50,
        //Set a random size for pill
        size = Math.floor(Math.random() * 120 + 80),
        //Set a random position of height for pill
        randTop = Math.floor(Math.random() * 70 + 10),
        randLeft = Math.floor(Math.random() * wrapperWidth + wrapperWidth),
        left =
          distances[pills.length - 1][index] === 40
            ? Math.floor(Math.random() * 70 + 0)
            : distances[pills.length - 1][index];

      // Runs on load to set random position and size
      $(this).css("width", size + "px");
      $(this).css("height", size + "px");
      $(this).css("left", left + "%");
      $(this).css("top", randTop + "%");

      gsap.timeline().to($(this), {
        x: `random(-${transformRange}, ${transformRange}, 1)`,
        y: `random(-${transformRange}, ${transformRange}, 1)`,
        duration: "random(18, 30, 1)",
        ease: "none",
        rotation: "random(-450, 450, 1)",
        repeat: -1,
        repeatRefresh: true, // gets a new random x and y value on each repeat
      });
    });
  });

  // *****************
  // Apply faint opacity to pills if landing content is more than half the height of the
  // landing container make landing content more visible and not blend in with pills
  // *****************
  const fadePills = () => {
    const landing = $(".landing-container .landing");
    const landingContentWrapper = landing.children(".landing-content-wrapper");
    const pills = landing.children(".pill-container");

    if (
      landing.height() < landingContentWrapper.height() + 100 &&
      window.innerWidth < 576
    ) {
      pills.addClass("fade");
      console.log("smaller");
    } else {
      pills.removeClass("fade");
    }
  };

  fadePills();
  blogPagePillAnimations($(".blog-post-article"));
  blogPagePillAnimations($(".title--hero-image"));

  // *****************
  // If column module has pill container give class
  // *****************
  $(".column-module .column:not(.span-3-quarters) .pill-wrapper")
    .parent()
    .addClass("d-flex flex-column");

  $(window).resize(function () {
    fadePills();
  });
};
